import { IonPage, IonSpinner } from "@ionic/react";
import { IonCol, IonContent, IonGrid, IonRow } from "@ionic/react";
import "./AuthenticationLoading.css";

const AuthenticationLoading = () => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid id="loginGrid">
          <IonRow id="loginRow">
            <IonCol id="loginMainContainer" size="12" size-md="6" offset-md="3">
              <div id="authenticationContainer">
                <IonSpinner />
                <p>Checking user authentication...</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default AuthenticationLoading;
